var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#111",
  d: "m17.436.75-5.86 1.83-5.181-1.293-5.83 1.638V17.25l.822-.233 5.028-1.415 5.201 1.303 5.82-1.82zm-1.298 1.764v11.619l-3.893 1.216V3.731zm-9.084.274 3.893.973V15.4l-3.893-.973zm-1.298.025v11.629l-3.893 1.095V3.908z"
})));
export default SvgMap;